const spinButtonImages = {
  NFL: '/images/spinButton/NFL-Spin-Button.png',
  NBA: '/images/spinButton/NBA-Spin-Button.png',
  MLB: '/images/spinButton/MLB-Spin-Button.png',
}

export default spinButtonImages
